import * as React from "react";
import { Graph } from "./Graph";
export const ResponsiveGraph = ({ data, graph, ignoreFileName, hideTitle, folderType, baseFileName, }) => {
    return (React.createElement(Graph, { data: data, graph: graph, ignoreFileName: ignoreFileName, hideTitle: hideTitle, folderType: folderType, baseFileName: baseFileName }));
};
//# sourceMappingURL=ResponsiveGraph.js.map